import {
  AddTeamMembersFnReq,
  AddTeamMembersFnRes,
  BULK_ADD_TEAM_MEMBERS_CLIENT_TIMEOUT_MS,
} from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';
import { GetAuthDtoInteractor } from '../../../auth/domain/interactors/get-auth-dto.interactor';

type AddTeamMembersResult = AddTeamMembersFnRes;

export class AddTeamMembersInteractor {
  private readonly addTeamMembersFn = httpsCallable<AddTeamMembersFnReq, AddTeamMembersFnRes>(
    this.functions,
    'addTeamMembers',
    { timeout: BULK_ADD_TEAM_MEMBERS_CLIENT_TIMEOUT_MS },
  );

  constructor(
    private readonly functions: Functions,
    private readonly getAuthDto: GetAuthDtoInteractor,
  ) {}

  public async execute(data: Omit<AddTeamMembersFnReq, 'auth'>): Promise<AddTeamMembersResult> {
    const res = await this.addTeamMembersFn({
      ...data,
      auth: await this.getAuthDto.execute(),
    });

    return res.data;
  }
}
